/**
 * ETP Testimonial Slider – Splide init.
 *
 * >1280px: active card capped at 880px (fixedWidth) + right peek of next card
 * ≤1280px: fixedWidth disabled → perPage:1 (slide fills container) + right peek
 *
 * Arrows are pre-rendered in PHP (with .splide__arrow--prev/--next classes)
 * and positioned below the track via CSS. Splide auto-detects them — do NOT
 * wire them manually, or each click triggers two go() calls and skips a slide.
 *
 * Breakpoints aligned with SCSS tokens: 1440=bp-l, 1280=bp-m, 900=bp-s, 600=bp-xs.
 */

export function initTestimonialSlider(scope) {
  const roots = (scope || document).querySelectorAll(
    '.etp-testimonial-slider:not([data-etp-testimonial-ready])'
  );

  const options = {
    type:        'loop',
    perMove:     1,
    fixedWidth:  '880px',
    gap:         '48px',
    pagination:  false,
    mediaQuery:  'max',
    breakpoints: {
      1440: { padding: { right: '300px' } },
      1280: { fixedWidth: 0, perPage: 1, gap: '32px', padding: { right: '80px' } },
      900:  { padding: { right: '100px' } },
      600:  { padding: { right: '0px' } },
    },
  };

  roots.forEach((el) => {
    if (!window.Splide) {
      console.warn('[ETP testimonial-slider] window.Splide missing.');
      return;
    }

    const hasTrack = !!el.querySelector('.splide__track');
    const hasList  = !!el.querySelector('.splide__list');

    if (!hasTrack || !hasList) {
      console.warn('[ETP testimonial-slider] skip init, incomplete markup.');
      return;
    }

    try {
      const splide = new window.Splide(el, options);
      splide.mount();

      el.dataset.etpTestimonialReady = 'true';
    } catch (e) {
      console.warn('[ETP testimonial-slider] init failed.', e);
    }
  });
}
